import { Box, styled, Theme, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const ChatMessagesHeader = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '32px 32px 24px 32px',
    borderBottom: '1px solid #D8DBE8',
    maxHeight: '130px',

    [theme.breakpoints.down('tablet')]: {
      padding: '10px',
    },
  };
});

export const CandidateListItemHeadingInfo = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',

    [theme.breakpoints.down('tablet')]: {
      gap: '8px',
    },
  };
});

export const CandidateListItemHeadingInfoTexts = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  };
});

export const CandidateListItemHeadingInfoTitle = styled(Typography)(({
  theme,
}: {
  theme: Theme;
}) => {
  return {
    color: palette.text.header,
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '130%',

    [theme.breakpoints.down('tablet')]: {
      fontSize: '14px',
      whiteSpace: 'pre-wrap',
    },

    '> span': {
      color: palette.text.placeholder,
      fontWeight: 500,
    },
  };
});

export const CandidateListItemHeadingInfoSalary = styled(Typography)(({
  theme,
}: {
  theme: Theme;
}) => {
  return {
    color: palette.text.header,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '128%',

    [theme.breakpoints.down('tablet')]: {
      fontSize: '12px',
    },
  };
});
